module.exports = __webpack_public_path__ + "img/icon-reserva.a6555479.svg";